import { Fragment } from "react";
import ResponsiveHeader from "../components/ResponsiveHeader";
import Footer2 from "../components/Footer2";
import almacenImg from "../images/GROBMX_almacen.jpeg";

const History = () => {
  const features = [
    {
      icon: "fa-globe",
      title: "Cobertura Extensiva",
      description:
        "GROB se enfoca en brindar la mayor cobertura posible del parque vehicular mexicano, asegurando que sus componentes estén disponibles para una amplia variedad de marcas y modelos desde automóviles subcompactos hasta vehículos utilitarios o deportivos.",
    },
    {
      icon: "fa-cogs",
      title: "Integración de Sistemas",
      description:
        "Al consolidar componentes de dirección, suspensión, tracción y amortiguación, GROB simplifica la experiencia del cliente, ofreciendo todo lo necesario para mantener en óptimas condiciones los vehículos que circulan en el país.",
    },
    {
      icon: "fa-car",
      title: "Enfoque en el Aftermarket",
      description:
        "Diseñada específicamente para atender las necesidades del mercado de repuesto, GROB proporciona productos que combinan precio competitivo con desempeño superior. Su enfoque garantiza disponibilidad, soporte técnico y facilidad de instalación.",
    },
    {
      icon: "fa-shield-halved",
      title: "Confianza Garantizada",
      description:
        "Respaldo técnico y garantías extensas que aseguran la tranquilidad de los consumidores e instaladores. Productos diseñados para cumplir con los más altos estándares de calidad.",
    },
    {
      icon: "fa-microchip",
      title: "Innovación y Tecnología",
      description:
        "Uso de materiales avanzados y procesos de fabricación de vanguardia para ofrecer productos de alta fiabilidad que igualan o superan las especificaciones originales.",
    },
    {
      icon: "fa-truck-fast",
      title: "Red de Distribución",
      description:
        "Acceso amplio a través de una red de distribuidores autorizados, con excelente disponibilidad en todo el territorio mexicano para atender las necesidades de nuestros clientes.",
    },
  ];

  return (
    <Fragment>
      <ResponsiveHeader />

      {/* Hero Banner */}
      <div className="historia-hero">
        <div className="container">
          <div className="historia-hero-content">
            <h1 className="historia-hero-title">Nuestra Historia</h1>
            <p className="historia-hero-subtitle">
              Más de cuatro décadas desarrollando soluciones automotrices de calidad
            </p>
          </div>
        </div>
      </div>

      {/* Sección Principal */}
      <div className="historia-section">
        <div className="container">
          {/* Imagen a todo lo ancho */}
          <div className="historia-intro-image-full">
            <img src={almacenImg} alt="Centro de distribución GROB" />
          </div>

          {/* Historia Introductoria */}
          <div className="historia-intro">
            <div className="historia-intro-badge">
              <i className="fa-solid fa-award"></i>
              <span>Desde 1980</span>
            </div>
            <h2 className="historia-intro-title">El Origen de GROB</h2>
            <p className="historia-intro-text">
              En 1980, nuestro Director General se fijó una meta: integrar y
              desarrollar componentes para los sistemas automotrices de
              dirección, suspensión, amortiguación y tracción en una
              estrategia enfocada a satisfacer las necesidades de los
              instaladores y mecánicos que buscan soluciones con una sola
              marca-proveedor. Así fue concebida y así nació nuestra marca
              GROB.
            </p>
            <p className="historia-intro-text">
              Los productos GROB cumplen con los más altos estándares de
              calidad, garantizando el mejor desempeño en rendimiento y
              durabilidad equivalentes a los componentes instalados de fábrica
              en los vehículos. Diseñados para adaptarse perfectamente a las
              especificaciones técnicas del mercado y las condiciones de
              manejo en México.
            </p>
          </div>

          {/* Grid de Características */}
          <div className="historia-features">
            <h2 className="historia-features-title">¿Por qué elegir GROB?</h2>
            <div className="historia-features-grid">
              {features.map((feature, index) => (
                <div key={index} className="historia-feature-card">
                  <div className="historia-feature-icon">
                    <i className={`fa-solid ${feature.icon}`}></i>
                  </div>
                  <h3 className="historia-feature-title">{feature.title}</h3>
                  <p className="historia-feature-description">
                    {feature.description}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      <Footer2 />
    </Fragment>
  );
};

export default History;
